import { Component, Input, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { EstateData } from 'src/lib/fliko/models/estate/estate.data';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { ContextData, ContextType } from '../../services/models/context.data';
import { ContextService } from '../../services/context.service';
import { ContextDataService } from '../../services/context.data-service';
import { CompanySelectComponent } from '../company-select/company-select.component';

@Component({
  selector: 'app-switch-context',
  templateUrl: './switch-context.component.html',
  styleUrls: ['./switch-context.component.scss']
})
export class SwitchContextComponent implements OnDestroy {
  @Input() estateControl: FormControl = new FormControl(null);
  @Input() contextType: ContextType = ContextType.ESTATE;
  @Input() contextData!: ContextData;
  @Input() estates: EstateData[] = [];

  CT = ContextType;

  private switchChangeId = 0;

  constructor(
    private dialogService: DialogService,
    private ctxDS: ContextDataService,
    private ctxSrv: ContextService,
    private localStorageSrv: LocalStorageService,
    private router: Router
  ) {}

  public get showCompanyButton(): boolean {
    return this.contextType === ContextType.COMPANY
      ? this.estates.length > 0
      : this.ctxDS.isUserSuperAdmin || this.contextData.hasCompanyAccess;
  }

  public async switchContext(): Promise<void> {
    const changeId = ++this.switchChangeId;
    const lastEstateId = this.localStorageSrv.selectedEstate.get(this.ctxDS.peekCurrentUserId());
    const estate =
      this.estates.find((entry) => entry.id === this.estateControl.value) ??
      this.estates.find((entry) => entry.id === lastEstateId) ??
      this.estates[0];

    if (this.contextType === ContextType.COMPANY) {
      if (!estate) return;
      this.ctxSrv.setContext(ContextType.ESTATE);
      await this.ctxSrv.setEstate(estate.id);
      if (changeId !== this.switchChangeId || this.ctxDS.peekContext() !== ContextType.ESTATE) return;
      this.router.navigate(['/dashboard']);
      return;
    }

    if (this.ctxDS.isUserSuperAdmin) {
      this.dialogService
        .openSimpleDialog(CompanySelectComponent, null, { width: '350px', height: '350px' })
        .afterClosed()
        .subscribe((companyId) => {
          if (companyId && changeId === this.switchChangeId) void this.changeToCompany(companyId, changeId);
        });
      return;
    }

    const companyId = estate?.companyId;
    await this.changeToCompany(
      companyId && this.contextData.companyIds.includes(companyId) ? companyId : (this.contextData.companyIds[0] ?? ''),
      changeId
    );
  }

  ngOnDestroy(): void {
    ++this.switchChangeId;
  }

  private async changeToCompany(id: string, changeId: number): Promise<void> {
    if (!id) return;
    this.ctxSrv.setContext(ContextType.COMPANY);
    await this.ctxSrv.setCompany(id);
    if (changeId !== this.switchChangeId || this.ctxDS.peekContext() !== ContextType.COMPANY) return;
    this.router.navigate(['/company']);
  }
}
